<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="bulk-update-icon"
    >
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
      <path d="M3 11h18" />
    </svg>
  </template>
  
  <script>
  export default {
    name: "BulkUpdateIcon",
  };
  </script>
  
  <style scoped>
  .bulk-update-icon {
    height: 100%;
    width: 100%;
  }
  </style>